import React from 'react';
import PropTypes from 'prop-types';

import './sponsor-image.scss';

const SponsorImage = ({
  link, image, alt, tier, paddingTop, paddingBottom,
}) => (
  <a href={link} className={tier} target="_blank">
    <img
      className="sponsor-image"
      src={image}
      alt={alt}
      style={{
        paddingTop,
        paddingBottom,
       }}
    />
  </a>
);

SponsorImage.propTypes = {
  link: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  tier: PropTypes.string.isRequired,
  paddingTop: PropTypes.string.isRequired,
  paddingBottom: PropTypes.string.isRequired,
};

export default SponsorImage;



// WEBPACK FOOTER //
// ./src/components/Sponsors/SponsorImage/index.jsx